/**
 * Settings Parser Utility
 *
 * @deprecated - Form field transformation is now handled in @sunrise-ui/api-client
 * This file is kept for backwards compatibility but re-exports from api-client.
 * Use useGetFormFields from @sunrise-ui/api-client which returns transformed data directly.
 */

// Re-export transformation utilities from api-client for backwards compatibility
export { transformFormFields as apiFieldsToRenderConfigs } from '@sunrise-ui/api-client';
